import { emptyGame, publicGame } from "./rules";
import { STARTER_FRIDGE, type Message, type Profile, type RoomState } from "./model";
import { uid } from "./id";

export { uid };

export function freshRoom(room: string, host: Profile): RoomState {
  return {
    room,
    members: [host],
    fridge: [...STARTER_FRIDGE],
    game: emptyGame(),
    messages: [
      {
        id: uid(),
        from: "hq",
        kind: "system",
        text: `Family HQ · ${room} · shoes off, phones on silent-ish`,
        at: Date.now(),
      },
    ],
  };
}

export function addMessage(state: RoomState, msg: Omit<Message, "id" | "at"> & { at?: number }): Message {
  const full: Message = { ...msg, id: uid(), at: msg.at ?? Date.now() };
  state.messages.push(full);
  if (state.messages.length > 200) state.messages.splice(0, state.messages.length - 200);
  return full;
}

export function upsertMember(state: RoomState, profile: Profile): void {
  const i = state.members.findIndex((m) => m.id === profile.id);
  if (i === -1) state.members.push(profile);
  else {
    const prev = state.members[i];
    if (!prev) return;
    state.members[i] = { ...prev, ...profile, score: prev.score };
  }
}

export function dropMember(state: RoomState, id: string): void {
  const member = state.members.find((m) => m.id === id);
  if (member) member.left = true;
}

export function addPoints(state: RoomState, id: string, points: number): void {
  const member = state.members.find((m) => m.id === id);
  if (member) member.score += points;
}

export function ranked(state: RoomState): Profile[] {
  return [...state.members].filter((m) => !m.left).sort((a, b) => b.score - a.score);
}

export function viewFor(state: RoomState, viewer: string): RoomState {
  return {
    ...state,
    game: publicGame(state.game, viewer),
  };
}
